import {
	FormContentSection,
	FormSectionCard,
	FormSectionTitle,
	GradientText,
	SubmitButton,
	SubmitButtonContainer,
	Wrapper,
} from '../PasserCommande/PasserCommande.styles'
import React, { useEffect, useState } from 'react'
import {
	getSingleTransporter,
	updateTransporterAccount,
} from '../../api/transporteurs'
import { useDispatch, useSelector } from 'react-redux'

import AddVehicleRegister from '../../Components/AddVehicle/AddVehicleRegister'
import { CustomInput } from '../RegisterTransporter/style'
import File from '../../assets/img/file@2x.png'
import LayoutTransporter from '../../Components/LayoutTransporter/LayoutTransporter'
import Modal from 'react-modal'
import { BASE_URL } from '../../api/base'
import UploadFile from '../../Components/UploadSingleFile/upload.component'
import toast from 'react-hot-toast'
import { updateProfile } from '../../redux/auth'
import { useForm, Controller } from 'react-hook-form'
import ActionModal from '../../Components/ValidationModal/ActionModal'
import { useUnsavedChanges } from '../../hooks/useUnsavedChanges'
import UnsavedChangesModal from '../../Components/UnsavedChangesModal'
import { Prompt } from "react-router-dom";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { validatePhoneNumber } from '../../utils/phoneValidator'
import { useAuthenticatedFetch } from '../../hooks'
import { useTranslation } from 'react-i18next'

// Make sure to bind modal to your appElement
Modal.setAppElement('#root')

function TransporterAccount() {
	const { _id } = useSelector((state) => state.auth.user)
	const token = useSelector((state) => state.auth.token);
	const [chargementEnCours, setChargementEnCours] = useState(false);
	const [loading, setLoading] = useState(false)
	const [transporter, setTransporter] = useState()
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [formData, setFormData] = useState(null)
	const [saveLoading, setSaveLoading] = useState(false);
	const [fileUrls, setFileUrls] = useState({});
	const [fileLoading, setFileLoading] = useState({});
	const {t} = useTranslation();
	const {
		fetchResource,
		error: fetchError,
		loading: fetchLoading,
	} = useAuthenticatedFetch()
	const dispatch = useDispatch()

	const handleFormSubmit = (data) => {
		setFormData(data)
		setIsModalOpen(true)
	}

	const formMethods = useForm()
	const {
		register,
		handleSubmit,
		setValue,
		reset,
		control,
		watch,
		getValues,
		formState: { errors },
	} = formMethods

	// Initialize unsaved changes detection
	const {
		hasUnsavedChanges,
		showUnsavedModal,
		handleUnsavedChanges,
		handleSaveChanges,
		handleDiscardChanges,
		handleCancelAction,
		updateInitialData
	} = useUnsavedChanges(formMethods, transporter);
	// Fonction pour charger les URLs des fichiers
	const loadFileUrls = async () => {
		if (!transporter) return;

		const urls = {};
		const loadingStates = {};
		const fileFields = [
			'fiscale', 'urssaf', 'assurance_marchandises', 'kbis',
			'licence_moins35t', 'licence_plus35t', 'capacite_transport',
			'piece_identite', 'rib', 'logo'
		];

		for (const field of fileFields) {
			const file = transporter[field];
			if (file && file.path) {
				loadingStates[field] = true;
				try {
					const url = await fetchResource(file.path, token);
					urls[field] = url;
				} catch (error) {
					console.error(`Error loading ${field}:`, error);
				} finally {
					loadingStates[field] = false;
				}
			}
		}

		// Charger les cartes grises des véhicules
		if (transporter.vehicules) {
			for (const vehicule of transporter.vehicules) {
				if (vehicule.carte_grise && vehicule.carte_grise.path) {
					const fieldId = `carte_grise_${vehicule._id}`;
					loadingStates[fieldId] = true;
					try {
						const url = await fetchResource(vehicule.carte_grise.path, token);
						urls[fieldId] = url;
					} catch (error) {
						console.error(`Erreur chargement carte grise véhicule ${vehicule._id}:`, error);
					} finally {
						loadingStates[fieldId] = false;
					}
				}
			}
		}

		setFileUrls(prev => ({ ...prev, ...urls }));
		setFileLoading(prev => ({ ...prev, ...loadingStates }));
	}

	async function fetchTransporter(_id) {
		setChargementEnCours(true)
		try {
			const data = await getSingleTransporter(_id, token)
			setTransporter(data)

			// Reset form with fetched data
			reset({
				quality: data.quality || '',
				address: data.address || '',
				city: data.city || '',
				postalCode: data.postalCode || '',
				phone: data.phone || '',
				password: '',
				rippeurs: data.rippeurs || 0,
				manutention: data.manutention || [],
				epi: data.epi || [],
				vehicules: data.vehicules || [],
				// Add other fields as needed
			});

			// Update initial data for comparison
			updateInitialData({
				quality: data.quality || '',
				address: data.address || '',
				city: data.city || '',
				postalCode: data.postalCode || '',
				phone: data.phone || '',
				password: '',
				rippeurs: data.rippeurs || 0,
				manutention: data.manutention || [],
				epi: data.epi || [],
				vehicules: data.vehicules || [],
			});
		} catch (error) {
			toast.error(t("transfer_request_err"), {
				style: {
					fontFamily: 'Montserrat',
				},
			});
		} finally {
			setChargementEnCours(false)
		}
	}

	useEffect(() => {
		fetchTransporter(_id)
	}, [_id])
	useEffect(() => {
		if (transporter) {
			loadFileUrls();
		}
	}, [transporter]);

	// Handle navigation attempts when there are unsaved changes
	useEffect(() => {
		const handlePopstate = (e) => {
			if (hasUnsavedChanges) {
				e.preventDefault();
				handleUnsavedChanges(() => {
					window.history.back();
				});
				window.history.pushState(null, '', window.location.href);
			}
		};

		window.addEventListener('popstate', handlePopstate);

		// Push a state to handle back button
		if (hasUnsavedChanges) {
			window.history.pushState(null, '', window.location.href);
		}

		return () => {
			window.removeEventListener('popstate', handlePopstate);
		};
	}, [hasUnsavedChanges, handleUnsavedChanges]);

	const onSubmit = async (data) => {
		setLoading(true)
		setSaveLoading(true);

		const modifiableData = {
			quality: data.quality,
			address: data.address,
			city: data.city,
			postalCode: data.postalCode,
			phone: data.phone,
			password: data.password,
			rippeurs: data.rippeurs,
			manutention: data.manutention,
			epi: data.epi,
			vehicules: data.vehicules
		}

		if (modifiableData.password.length === 0) {
			delete modifiableData.password
		}

		const modifiedFiles = [];
		const fileFields = [
			'fiscale',
			'urssaf',
			'assurance_marchandises',
			'kbis',
			'licence_moins35t',
			'licence_plus35t',
			'capacite_transport',
			'piece_identite',
			'rib',
			'logo'
		];

		fileFields.forEach(field => {
			if (data[field]) {
				modifiedFiles.push({
					[field]: data[field]
				});
			}
			delete data[field];
		});

		if (Array.isArray(data.vehicules)) {
			data.vehicules.forEach((vehicule, index) => {
				const { immatriculation, carte_grise } = vehicule;

				if (carte_grise) {
					if (carte_grise && Object.prototype.toString.call(carte_grise) === '[object File]') {
						modifiedFiles.push({
							[`carte_grise_${index}_${immatriculation}`]: carte_grise,
						});
						delete vehicule.carte_grise;
					} else {
						console.warn(`La carte grise pour l'immatriculation ${immatriculation} n'est pas un fichier valide.`);
					}
				}
			});
		}

		try {
			console.log('modifiableData', modifiableData)
			const res = await updateTransporterAccount(_id, modifiableData, modifiedFiles, token)

			toast.success(t("account_updated"), {
				style: {
					fontFamily: 'Montserrat',
				},
			})

			dispatch(updateProfile(res))

			// Update initial data after successful save
			updateInitialData(getValues());

			setTimeout(() => {
				window.location.reload();
			}, 1000);
		} catch (error) {
			toast.error(t("transfer_request_err"), {
				style: {
					fontFamily: 'Montserrat',
				},
			})
		} finally {
			setLoading(false)
			setIsModalOpen(false)
			setSaveLoading(false);
		}
	}
	const renderHandlingEq = (eq) => {
    switch (eq) {
      case "Diable":
        return t("handling_eq1");
      case "Transpalette manuel":
        return t("handling_eq2");
      case "Transpalette électrique":
        return t("handling_eq3");
      case "Sangle":
        return t("handling_eq4");
      default:
        return eq;
    }
  };
  const renderPPEq = (eq) => {
    switch (eq) {
      case "Casque":
        return t("ppe_eq1");
      case "Gants":
        return t("ppe_eq2");
      case "Masque":
        return t("ppe_eq3");
      case "Lunettes":
        return t("ppe_eq4");
      case "Chaussure de sécurité":
        return t("ppe_eq5");
      case "Gilet de visibilité":
        return t("ppe_eq6");
      default:
        return eq;
    }
  };
	const [isSmallScreen, setSmallScreen] = useState(() => window.innerWidth < 768);


	useEffect(() => {
		const checkIfMobile = () => {
			setSmallScreen(window.innerWidth < 768);
		};
		window.addEventListener('resize', checkIfMobile);

		return () => window.removeEventListener('resize', checkIfMobile);
	}, []);

	return (
		<LayoutTransporter>
			<div
				style={{
					width: '100%',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
					paddingTop: '2rem',
					paddingBottom: '4rem',
					paddingLeft: '1.5rem',
					paddingRight: '1.5rem',
				}}
			>
				<Wrapper>
					<GradientText
						style={{
							fontSize: isSmallScreen ? '2rem' : '2.5rem'
						}}
					>{t("my_account")}</GradientText>
					{hasUnsavedChanges && (
						<div style={{
							backgroundColor: '#fef3c7',
							border: '1px solid #f59e0b',
							borderRadius: '8px',
							padding: '12px 16px',
							marginTop: '1rem',
							display: 'flex',
							alignItems: 'center',
							gap: '8px',
							fontFamily: 'Montserrat',
							fontSize: '14px',
							color: '#92400e'
						}}>
							<span>⚠️</span>
							<span>{t("unsaved_changed")}</span>
						</div>
					)}
				</Wrapper>

				{chargementEnCours ? (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							backgroundColor: 'white',
							marginTop: "10rem"
						}}
					>
						<div className='customLoader'></div>
					</div>
				) : (

					<div
						style={{
							width: '100%',
							fontFamily: 'Montserrat',
							alignSelf: 'center',
						}}
					>
						<form onSubmit={handleSubmit(handleFormSubmit)}>
							<FormSectionCard>
								<div style={{
									display: 'flex',
									flexDirection: isSmallScreen ? 'column' : 'row',
								}}>
									<div
										style={{
											width: isSmallScreen ? '100%' : '50%',
											display: 'flex',
											flexDirection: 'column',
											paddingBottom: '2rem',
											marginRight: '1rem'
										}}
									>
										<span
											style={{
												color: '#262626',
												paddingBottom: '1rem',
											}}
										>
											{t("company_name")}
										</span>
										<CustomInput
											type='text'
											disabled
											placeholder='Wayne'
											defaultValue={transporter?.societe}
											style={{
												backgroundColor: '#f0f0f0',
												color: '#a9a9a9',
												cursor: 'not-allowed'
											}}
										/>
									</div>

									<div
										style={{
											width: isSmallScreen ? '100%' : '50%',
											display: 'flex',
											flexDirection: 'column',
											paddingBottom: '2rem',
										}}
									>
										<span
											style={{
												color: '#262626',
												paddingBottom: '1rem',
											}}
										>
											{t("last_name")}
										</span>
										<CustomInput
											type='text'
											disabled
											placeholder='Doe'
											defaultValue={transporter?.last_name}
											style={{
												backgroundColor: '#f0f0f0',
												color: '#a9a9a9',
												cursor: 'not-allowed'
											}}
										/>
									</div>
								</div>
								<div style={{
									display: 'flex',
									flexDirection: isSmallScreen ? 'column' : 'row',
								}}>
									<div
										style={{
											width: isSmallScreen ? '100%' : '50%',
											display: 'flex',
											flexDirection: 'column',
											paddingBottom: '2rem',
											marginRight: '1rem'
										}}
									>
										<span
											style={{
												color: '#262626',
												paddingBottom: '1rem',
											}}
										>
											{t("first_name")}
										</span>
										<CustomInput
											type='text'
											disabled
											placeholder='John'
											defaultValue={transporter?.first_name}
											style={{
												backgroundColor: '#f0f0f0',
												color: '#a9a9a9',
												cursor: 'not-allowed'
											}}
										/>
									</div>

									<div
										style={{
											width: isSmallScreen ? '100%' : '50%',
											display: 'flex',
											flexDirection: 'column',
											paddingBottom: '2rem',
										}}
									>
										<span
											style={{
												color: '#262626',
												paddingBottom: '1rem',
											}}
										>
											{t("quality")}
										</span>
										<Controller
											name="quality"
											control={control}
											defaultValue={transporter?.quality}
											rules={{
												required: t("enter_job_position"),
												minLength: {
													value: 3,
													message: t("article_f") +t("quality") +t("err_message2"),
												},
												pattern: {
													value: /^[A-Za-zÀ-ÖØ-öø-ÿ\s'\-]+$/,
													message: t("article_f") +t("quality") +t("err_message2")
												},
											}}
											render={({ field }) => (
												<CustomInput
													type="text"
													placeholder={t("operations_director")}
													{...field}
												/>
											)}
										/>
										{errors.quality && (
											<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
												{errors.quality.message}
											</div>
										)}
									</div>
								</div>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										paddingBottom: '2rem',
									}}
								>
									<span
										style={{
											color: '#262626',
											paddingBottom: '1rem',
										}}
									>
										{t("address")}
									</span>
									<Controller
										name="address"
										control={control}
										defaultValue={transporter?.address}
										rules={{
											required: t("enter_address"),
											minLength: {
												value: 3,
												message: t("article_elided") +t("address") +t("err_message2"),
											},
											pattern: {
												value: /^[A-Za-zÀ-ÿ0-9\s',.\-/()°]+$/,
												message: t("article_elided") +t("address") +t("err_message3"),

											},
										}}
										render={({ field }) => (
											<CustomInput
												type='text'
												placeholder='54 rue avenue de la grande armée, 75017, Paris, France'
												{...field}
											/>
										)}
									/>
									{errors.address && (
										<div style={{ color: 'red', marginTop: '0.5rem', fontSize: "14px" }}>
											{errors.address.message}
										</div>
									)}
								</div>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										paddingBottom: '2rem',
									}}
								>
									<span
										style={{
											color: '#262626',
											paddingBottom: '1rem',
										}}
									>
										{t("city")}
									</span>
									<Controller
										name="city"
										control={control}
										defaultValue={transporter?.city}
										rules={{
											required: t("enter_city"),
											minLength: {
												value: 3,
												message: t("article_f") +t("city") +t("err_message2"),
											},
											pattern: {
												value: /^.+$/,
												message: t("article_f") +t("city") +t("err_message3"),
											},
										}}
										render={({ field }) => (
											<CustomInput
												type='text'
												placeholder='Paris'
												{...field}
											/>
										)}
									/>

									{errors.city && (
										<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
											{errors.city.message}
										</div>
									)}
								</div>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										paddingBottom: '2rem',
									}}
								>
									<span
										style={{
											color: '#262626',
											paddingBottom: '1rem',
										}}
									>
										{t("zip_code")}
									</span>

									<Controller
										name="postalCode"
										control={control}
										defaultValue={transporter?.postalCode}
										rules={{
											required: t("enter_postal_code"),
											pattern: {
												value: /^\d{5}$/,
												message: t("zip_code_err_message"),
											},
										}}
										render={({ field }) => (
											<CustomInput
												type='text'
												placeholder='75017'
												{...field}
											/>
										)}
									/>
									{errors.postalCode && (
										<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
											{errors.postalCode.message}
										</div>
									)}
								</div>
								<div style={{
									display: 'flex',
									flexDirection: isSmallScreen ? 'column' : 'row',
								}}>
									<div
										style={{
											width: isSmallScreen ? '100%' : '50%',
											display: 'flex',
											flexDirection: 'column',
											paddingBottom: '2rem',
											marginRight: "1rem"
										}}
									>
										<span
											style={{
												color: '#262626',
												paddingBottom: '1rem',
											}}
										>
											Email
										</span>
										<CustomInput
											type='text'
											disabled
											placeholder='test@gmail.com'
											defaultValue={transporter?.email}
											style={{
												backgroundColor: '#f0f0f0',
												color: '#a9a9a9',
												cursor: 'not-allowed'
											}}
										/>
									</div>
									<div
										style={{
											width: isSmallScreen ? '100%' : '50%',
											display: 'flex',
											flexDirection: 'column',
											paddingBottom: '2rem',
										}}
									>
										<span
											style={{
												color: '#262626',
												paddingBottom: '1rem',
											}}
										>
											{t("contact_us_formulair_item2")}
										</span>
										<Controller
											name="phone"
											control={control}
											defaultValue={transporter?.phone}
											rules={{
												validate: validatePhoneNumber
											}}
											render={({ field }) => (
												<PhoneInput
													country={'fr'}
													value={field.value}
													onChange={(phone, countryData) => {
														// Stocker le numéro avec le code pays
														field.onChange(phone);
													}}
													inputProps={{
														name: field.name,
														required: true,
													}}
													inputStyle={{
														paddingRight: '1.5rem',
														paddingTop: '1.5rem',
														paddingBottom: '1.5rem',
														borderRadius: '0.5rem',
														border: 'none',
														fontFamily: 'Montserrat',
														color: '#858ea8',
														flex: '1',
														display: 'flex',
														width: '100%',
													}}
													buttonStyle={{
														borderRadius: '0.5rem',
														border: 'none',
														fontFamily: 'Montserrat',
														color: '#858ea8',
														flex: '1',
														display: 'flex',
													}}

													containerStyle={{
														width: '100%',
													}}
													placeholder="(0) 01 45 66 32 88"
													enableSearch={true}
													searchPlaceholder={t("search_for_country")}
												/>
											)}
										/>
										{errors.phone && (
											<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
												{errors.phone.message}
											</div>
										)}
									</div>


								</div>
								<div
									style={{
										display: 'flex',
										flexDirection: 'row',
									}}
								>
									<div
										style={{
											width: isSmallScreen ? '100%' : '50%',
											display: 'flex',
											flexDirection: 'column',
											paddingBottom: '2rem',
										}}
									>
										<div
											style={{
												display: 'flex',
												flexDirection: 'row',
												justifyContent: 'space-between',
											}}
										>
											<span
												style={{
													color: '#262626',
													paddingBottom: '1rem',
												}}
											>
												{t("change_password")}
											</span>
										</div>
										<CustomInput
											autoComplete='new-password'
											placeholder={t("password_placeholder")}
											{...register('password', {
												minLength: {
													value: 8,
													message: t("mdp_err_message"),
												},
											})}
										/>
										{errors.password && (
											<div style={{ color: 'red', marginTop: '0.5rem', fontSize: '14px' }}>
												{errors.password.message}
											</div>
										)}
									</div>
									<div style={{ width: '1rem' }} />
								</div>
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										marginBottom: '1rem',
										width: isSmallScreen ? '100%' : '50%',
										fontFamily: 'Montserrat',
										//marginLeft: 10,
										marginTop: 10,
									}}
								>
									<div
										style={{
											display: 'flex',
											flexDirection: 'row',
											justifyContent: 'space-between',
										}}
									>
										<span
											style={{
												marginBottom: '1rem',
												color: 'black',
												fontSize: 14,
											}}
										>
											Logo(PNG {t("or")} JPG)
										</span>
										<span
											style={{
												marginBottom: '1rem',
												color: '#838EAB',
												fontSize: 14,
											}}
										>
											({t("optional")})
										</span>
									</div>

									<Controller
										name='logo'
										control={control}
										render={({ field }) => (
											<UploadFile
												name={field.name}
												accept={'.jpg, .png'}
												setValue={setValue}
												{...field}
											/>
										)}
									/>
									{transporter?.logo && transporter.logo.mimetype !== 'application/pdf' && (
										<>
											{fileLoading.logo ? (
												<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 100 }}>
													<div className='customLoader' style={{ transform: 'scale(0.5)' }}></div>
												</div>
											) : (
												<img
													style={{ width: 100, height: 100, borderRadius: 5, objectFit: 'cover' }}
													src={fileUrls.logo || `${BASE_URL}/${transporter.logo.path}`}
													alt="Logo"
												/>
											)}
										</>
									)}

									{transporter?.logo && transporter.logo.mimetype === 'application/pdf' && (
										<div style={{ display: 'flex', flexDirection: 'row' }}>
											<img src={File} style={{ height: 20, marginRight: '1rem' }} alt="PDF icon" />
											{fileLoading.logo ? (
												<div>{t("loading")}...</div>
											) : (
												<span
													style={{ cursor: 'pointer' }}
													onClick={() => window.open(fileUrls.logo || `${BASE_URL}/${transporter.logo.path}`)}
												>
													{transporter.logo.name}
												</span>
											)}
										</div>
									)}
								</div>
							</FormSectionCard>

							<div style={{ height: '2rem' }} />

							<Controller
								name="vehicules"
								control={control}
								defaultValue={transporter?.vehicules}
								rules={{ required: t("add_vehicle_err") }}
								render={({ field }) => (
									<>
										<AddVehicleRegister
											initialVehicles={transporter?.vehicules}
											fileUrls={fileUrls}
											onChange={(items) => {
												setValue('vehicules', items)
											}}
										/>
										{errors.vehicules && (
											<p style={{ color: 'red' }}>{errors.vehicules.message}</p>
										)}
									</>
								)}
							/>

							<div style={{ height: '2rem' }} />

							<FormContentSection>
								<FormSectionTitle>{t("rippeur")}</FormSectionTitle>
								<FormSectionCard>
									<div
										style={{
											width: '100%',
											display: 'flex',
											flexDirection: 'column',
										}}
									>
										<span
											style={{
												marginBottom: '1rem',
												color: 'black',
												fontSize: 14,
											}}
										>
											{t("rippeur_p")}
										</span>

										<div
											style={{
												display: 'flex',
												flexDirection: 'row',
												alignItems: 'center',
												justifyContent: 'center',
											}}
										>
											<div>
												<svg
													xmlns='http://www.w3.org/2000/svg'
													width='13.605'
													height='27.839'
													viewBox='0 0 13.605 27.839'
													style={{
														marginRight: '.5rem',
													}}
												>
													<g
														id='user'
														transform='translate(0.5 0.5)'
													>
														<path
															id='Path_11624'
															d='M31.488,8.816A3.412,3.412,0,1,1,34.9,5.4,3.412,3.412,0,0,1,31.488,8.816Zm0-6.054a2.645,2.645,0,1,0,2.645,2.645A2.645,2.645,0,0,0,31.488,2.762Z'
															transform='translate(-25.195 -1.992)'
															fill='#51c7f2'
															stroke='#51c7f2'
															strokeWidth='1'
														/>
														<path
															id='Path_11625'
															d='M30.917,33.11h-.752a.383.383,0,1,1,0-.767h.752A1.484,1.484,0,0,0,32.4,30.861V24.829a1.7,1.7,0,0,0-1.7-1.7H23.03a1.7,1.7,0,0,0-1.7,1.7v6.034a1.484,1.484,0,0,0,1.484,1.481h.725a.383.383,0,1,1,0,.767h-.725a2.252,2.252,0,0,1-2.249-2.249V24.829A2.472,2.472,0,0,1,23.03,22.36H30.7a2.472,2.472,0,0,1,2.469,2.469v6.034A2.252,2.252,0,0,1,30.917,33.11Z'
															transform='translate(-20.562 -14.552)'
															fill='#51c7f2'
															stroke='#51c7f2'
															strokeWidth='1'
														/>
														<path
															id='Path_11626'
															d='M38.027,48.646A2.029,2.029,0,0,1,36,46.619V40.231a.383.383,0,0,1,.767,0v6.388a1.26,1.26,0,0,0,2.52,0V34.509a.383.383,0,0,1,.767,0v12.11A2.029,2.029,0,0,1,38.027,48.646Z'
															transform='translate(-30.081 -21.807)'
															fill='#51c7f2'
															stroke='#51c7f2'
															strokeWidth='1'
														/>
														<path
															id='Path_11627'
															d='M29.453,48.646a2.029,2.029,0,0,1-2.027-2.027V34.509a.383.383,0,0,1,.767,0v12.11a1.26,1.26,0,0,0,2.52,0V40.231a.383.383,0,0,1,.767,0v6.388A2.029,2.029,0,0,1,29.453,48.646Z'
															transform='translate(-24.794 -21.807)'
															fill='#51c7f2'
															stroke='#51c7f2'
															strokeWidth='1'
														/>
													</g>
												</svg>
											</div>

											<Controller
												name="rippeurs"
												control={control}
												defaultValue={transporter?.rippeurs}
												render={({ field }) => (
													<CustomInput
														width={'100%'}
														type='number'
														min={0}
														{...field}
													/>
												)}
											/>
										</div>
									</div>
								</FormSectionCard>
							</FormContentSection>

							<div style={{ height: '2rem' }} />

							<FormContentSection>
								<FormSectionTitle>
									{t("additional_equipment")}
								</FormSectionTitle>
								<FormSectionCard>
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
										}}
									>
										<span
											style={{
												marginBottom: '1rem',
												color: 'black',
												fontSize: 14,
											}}
										>
											{t("handling_equipment")}
										</span>

										<div
											style={{
												display: 'flex',
												flexWrap: 'wrap',
												flexDirection: isSmallScreen ? 'column' : 'row',
												marginBottom: '1rem',
											}}
										>
											{[
												'Diable',
												'Transpalette manuel',
												'Transpalette électrique',
												'Sangle',
											].map((item, index) => (
												<div
													key={String(index)}
													style={{
														width: isSmallScreen ? '100%' : '33%',
														display: 'flex',
														alignItems: 'center',
														justifyContent:
															'flex-start',
														marginBottom: '1rem',
													}}
												>
													<input
														type='checkbox'
														style={{
															marginRight: '1rem',
														}}
														{...register(
															'manutention',
															{
																required: true,
															}
														)}
														value={item}
													/>

													<span>{renderHandlingEq(item)}</span>
												</div>
											))}
										</div>
										{errors.manutention && (
											<div style={{ color: 'red', marginTop: '0.5rem', marginBottom: '1rem', fontSize: "14px" }}>
												{t("handling_equipment_err")}
											</div>
										)}
									</div>

									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
										}}
									>
										<span
											style={{
												marginBottom: '1rem',
												color: 'black',
												fontSize: 14,
											}}
										>
											{t("ppe")}
										</span>

										<div
											style={{
												display: 'flex',
												flexWrap: 'wrap',
												flexDirection: isSmallScreen ? 'column' : 'row',
											}}
										>
											{[
												'Casque',
												'Gants',
												'Masque',
												'Lunettes',
												'Chaussure de sécurité',
												'Gilet de visibilité',
											].map((item, index) => (
												<div
													key={String(index)}
													style={{
														width: isSmallScreen ? '100%' : '27%',
														display: 'flex',
														alignItems: 'center',
														justifyContent:
															'flex-start',
														marginBottom: '1rem',
														paddingRight: '5px'

													}}
												>
													<input
														type='checkbox'
														style={{
															marginRight: '1rem',
														}}
														{...register('epi', {
															required: true,
														})}
														value={item}
													/>

													<span>{renderPPEq(item)}</span>
												</div>
											))}
										</div>
									</div>
									{errors.epi && (
										<div style={{ color: 'red', marginTop: '0.5rem' }}>
											{t("ppe_err")}
										</div>
									)}
								</FormSectionCard>
							</FormContentSection>
							<div style={{ height: '2rem' }} />
							<FormContentSection>
								<FormSectionTitle>{t("administrative_documents")}</FormSectionTitle>
								<FormSectionCard>
									<div
										style={{
											display: 'flex',
											flexDirection: 'column',
											marginBottom: '1rem',
										}}
									>
										{[
											{ name: 'fiscale', label: t("administrative_documents_d1") },
											{ name: 'urssaf', label: t("administrative_documents_d2") },
											{ name: 'assurance_marchandises', label: t("administrative_documents_d3") },
											{ name: 'kbis', label: t("administrative_documents_d4")},
											{ name: 'licence_moins35t', label: t("administrative_documents_d5")},
											{ name: 'licence_plus35t', label: t("administrative_documents_d6") },
											{ name: 'capacite_transport', label: t("administrative_documents_d7") },
											{ name: 'piece_identite', label: `${t("id_card")} (PDF)` },
											{ name: 'rib', label: t("administrative_documents_d9") },

										].reduce((rows, field, index, array) => {
											if (index % 2 === 0) {
												rows.push(array.slice(index, index + 2));
											}
											return rows;
										}, []).map((pair, index) => (
											<div
												key={index}
												style={{
													display: 'flex',
													flexDirection: isSmallScreen ? 'column' : 'row',
													marginBottom: '1rem',
												}}
											>
												{pair.map((field) => (
													<div
														key={field.name}
														style={{
															display: 'flex',
															flexDirection: 'column',
															width: isSmallScreen ? 'calc(100% - 1rem)' : 'calc(50% - 1rem)',
															fontFamily: 'Montserrat',
															marginLeft: 10,
															marginTop: 10,
														}}
													>
														<span
															style={{
																marginBottom: '1rem',
																color: 'black',
																fontSize: 14,
															}}
														>
															{field.label}
														</span>

														<div style={{
															display: 'flex',
															flexDirection: 'column',
														}}>

															<div>
																<Controller
																	name={field.name}
																	control={control}
																	render={({ field }) => (
																		<UploadFile
																			name={field.name}
																			accept={'.pdf'}
																			setValue={setValue}
																			{...field}
																		/>
																	)}
																/>
																{errors[field.name] && (
																	<span style={{ color: 'red', fontSize: '14px' }}>
																		{errors[field.name]?.message}
																	</span>
																)}
															</div>
															{transporter?.[field.name] && (
																<div style={{ display: 'flex', flexDirection: 'row' }}>
																	<img src={File} style={{ height: 20, marginRight: '1rem' }} alt="PDF icon" />
																	{fileLoading[field.name] ? (
																		<div>{t("loading")}...</div>
																	) : (
																		<span
																			style={{
																				cursor: 'pointer',
																				color: '#007bff',
																				overflow: 'hidden',
																				whiteSpace: 'normal',        // allow wrapping
																				overflowWrap: 'anywhere',
																			}}
																			onClick={() => window.open(fileUrls[field.name] || `${BASE_URL}/${transporter[field.name].path}`)}
																		>
																			{transporter[field.name].name}
																		</span>
																	)}
																</div>
															)}
														</div>



													</div>
												))}

											</div>
										))}
									</div>


								</FormSectionCard>
							</FormContentSection>
							<div style={{ height: '1rem' }} />
							<SubmitButtonContainer>
								<SubmitButton type='submit' disabled={loading}>
									{loading ? `${t("saving")}...` : t("save")}
								</SubmitButton>
							</SubmitButtonContainer>
						</form>
					</div>

				)}
			</div>

			<Prompt
				when={hasUnsavedChanges}
				message={(location) => {
					handleUnsavedChanges(() => {
						window.location.href = location.pathname;
					});
					return false;
				}}
			/>
			<UnsavedChangesModal
				isOpen={showUnsavedModal}
				onSave={() => handleSaveChanges(onSubmit)}
				onDiscard={handleDiscardChanges}
				onCancel={handleCancelAction}
				isLoading={saveLoading}
			/>

			{/* Confirmation Modal */}
			<ActionModal
				isOpen={isModalOpen}
				onRequestClose={() => { setIsModalOpen(false) }}
				title={t("confirm_changes")}
				message={t("save_changes_confirmation")}
				onConfirm={async () => {
					await onSubmit(formData)
				}}
				onCancel={() => {
					setIsModalOpen(false)
				}}
				isLoading={loading}
			/>
		</LayoutTransporter>
	)
}

export default TransporterAccount